const JumpingRope = (props) => (
  <svg
    fill="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 166.223 166.223"
    {...props}
  >
    <path d="M139.548,82.723V64.83C139.548,29.081,114.082,0,82.777,0c-31.3,0-56.767,29.081-56.767,64.83v18.012 
      c-5.003,1.123-8.741,5.581-8.741,10.904v61.27c0,6.189,5.02,11.207,11.207,11.207c6.186,0,11.206-5.018,11.206-11.207V93.736 
      c0-5.09-3.417-9.347-8.068-10.707v-18.21c0-32.654,22.949-59.226,51.164-59.226c28.216,0,51.167,26.572,51.167,59.226v18.419 
      c-4.313,1.555-7.405,5.661-7.405,10.499v61.274c0,6.183,5.02,11.206,11.207,11.206c6.19,0,11.206-5.023,11.206-11.206V93.736 
      C148.952,88.165,144.865,83.585,139.548,82.723z"/>
  </svg>
);

export default JumpingRope;
